import { TableBody, TableRow, styled } from "@mui/material";
import { StyledTableCell } from "./TableCell";
import { RowConfig } from "./table.types";
import { TableEmpty } from "./TableEmpty";
import { useDarkModeTheme } from "hooks/useDarkmodeTheme";
import { useMemo } from "react";

export const StyledTableRow = styled(TableRow)<{ 
  $isDarkMode: boolean;
  $rowOddThemeColor: string;
  $rowEvenThemeColor: string;
}>(({ $rowOddThemeColor, $rowEvenThemeColor, $isDarkMode }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: $rowOddThemeColor,//$isDarkMode ? "#1e1e1e" : "#f9f9f9",
    "& td": {
      color: $isDarkMode ? "#FFFFFF" : "#000000", // text color
    },
  },
  "&:nth-of-type(even)": {
    backgroundColor: $rowEvenThemeColor,//$isDarkMode ? "#2c2c2c" : "#ffffff",
    "& td": {
      color: $isDarkMode ? "#FFFFFF" : "#000000", // text color
    },
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface TableRowsProps {
  rows: RowConfig[];
  tableEmptyText?: string;
}
export const TableRows = ({
  rows,
  tableEmptyText = "No items found",
}: TableRowsProps) => {

  const { rowOddThemeColor, rowEvenThemeColor, isDarkModeOn } = useDarkModeTheme();

  return (
    <TableBody>
      {rows.length ? (
        <>
          {rows.map(({ name, rowFields }) => (
            <StyledTableRow key={name} $rowOddThemeColor={rowOddThemeColor} $rowEvenThemeColor={rowEvenThemeColor} $isDarkMode={isDarkModeOn}>
              {rowFields.map(({ fieldValue, component }, index) => {
                if (component) {
                  return (
                    <StyledTableCell
                      key={`${fieldValue}-${index}`}
                      align="left"
                    >
                      {component}
                    </StyledTableCell>
                  );
                }
                return (
                  <StyledTableCell key={`${fieldValue}-${index}`} align="left">
                    {fieldValue}
                  </StyledTableCell>
                );
              })}
            </StyledTableRow>
          ))}
        </>
      ) : (
        <TableEmpty displayText={tableEmptyText} />
      )}
    </TableBody>
  );
};
